export class ContratoCategoriaModel {
    idContratoCategoria: number;
    idCategoria: string;

    constructor(idContratoCategoria: number, idCategoria: string) {
        this.idContratoCategoria = idContratoCategoria;
        this.idCategoria = idCategoria;
    }

    static fromApiResponse(data: any): ContratoCategoriaModel {
        return new ContratoCategoriaModel(
            data.id_contrato_categoria,
            data.ID_CATEGORIA
        );
    }
}

export default class PlansByClubModel {
    idCategoria: string;
    categoria: string;
    valor: string;
    idClube: string;
    valorTitular: string;
    tipo: string;
    seqTitulo: string | null;
    ativo: string;
    idCentroCusto: number;
    idPlano: number | null;
    idTaxa: number | null;
    direitoVoto: string | null;
    permiteConvite: string | null;
    contratoCategorias: ContratoCategoriaModel[];

    constructor(
        idCategoria: string,
        categoria: string,
        valor: string,
        idClube: string,
        valorTitular: string,
        tipo: string,
        seqTitulo: string | null,
        ativo: string,
        idCentroCusto: number,
        idPlano: number | null,
        idTaxa: number | null,
        direitoVoto: string | null,
        permiteConvite: string | null,
        contratoCategorias: ContratoCategoriaModel[]
    ) {
        this.idCategoria = idCategoria;
        this.categoria = categoria;
        this.valor = valor;
        this.idClube = idClube;
        this.valorTitular = valorTitular;
        this.tipo = tipo;
        this.seqTitulo = seqTitulo;
        this.ativo = ativo;
        this.idCentroCusto = idCentroCusto;
        this.idPlano = idPlano;
        this.idTaxa = idTaxa;
        this.direitoVoto = direitoVoto;
        this.permiteConvite = permiteConvite;
        this.contratoCategorias = contratoCategorias;
    }

    static fromApiResponse(data: any): PlansByClubModel {
        const contratoCategorias = (data.sec_contrato_categoria || []).map((item: any) =>
            ContratoCategoriaModel.fromApiResponse(item)
        );

        return new PlansByClubModel(
            data.id_categoria,
            data.categoria,
            data.valor,
            data.id_clube,
            data.valor_titular,
            data.TIPO,
            data.SEQ_TITULO,
            data.ATIVO,
            data.ID_CENTRO_CUSTO,
            data.ID_PLANO,
            data.ID_TAXA,
            data.DIREITO_VOTO,
            data.PERMITE_CONVITE,
            contratoCategorias
        );
    }
}
